import { useState, useEffect, useCallback } from 'react';

function useDropdown(ref) { 
  let event = 'mousedown';
  if (arguments && arguments.length == 2) { // allows for useDropdown(ref, "eventName");
    event = arguments[1];
  }

  const [showDropdown, setShowDropdown] = useState(false);
  const callback = useCallback(({ target }) => {
    if (ref.current && !ref.current.contains(target)) {
      setShowDropdown(!showDropdown);
    }
  }, [showDropdown]);
  
  useEffect(() => {
    if (showDropdown) window.addEventListener(event, callback);
    return () => window.removeEventListener(event, callback);
  }, [showDropdown, callback])
  return [showDropdown, setShowDropdown];
}

export { useDropdown };
